import React from "react";
import {Modal, Paper} from "@material-ui/core";
import useStyles from "./useStyles";

const StripePaymentSuccessPopup = ({ isOpen, onClose }) => {
    const classes = useStyles();

    return(
        <Modal
            open={isOpen}
            onClose={()=>{}}
            aria-labelledby="multi-stepper-modal-title"
            aria-describedby="multi-stepper-modal-description"
            className={`${classes.modalWrapper} global-xs-modal add_list_modal`}
        >
            <Paper className={classes.modalInner}>
                <div className={classes.modalBody}>
                    <div className={classes.bodyContainer}>
                        <div className={classes.bodyTextContainer}>
                            <div className={classes.imageContainer}>
                                <img
                                    src={`${process.env.REACT_APP_CDN_LINK}asset/images/registration/releases/1.0.0/congratulations.png`}
                                    alt="Congratulation"
                                    className={classes.congratulationImage}
                                />
                            </div>
                            <div className={classes.reasonTitle}>
                                Thank You for Your Payment
                            </div>
                            <span className={classes.messageTitle}>
                                  Your payment has been successfully processed. Your subscription package is now active and updated.
                              </span>
                            <span className={classes.messageTitle} style={{ marginTop: "15px" }}>
                                  You can manage your subscription from your billing settings.
                            </span>
                            <div className={classes.actionContainer}>
                                <a className={classes.actionButton} onClick={onClose}>
                                    Let’s Go
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Paper>
        </Modal>
    );
};

export default StripePaymentSuccessPopup;